import { render } from "./DataIn.vue?vue&type=template&id=5f207379"
import script from "./DataIn.vue?vue&type=script&lang=js"
export * from "./DataIn.vue?vue&type=script&lang=js"

import "./DataIn.vue?vue&type=style&index=0&id=5f207379&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__